<div class="content grid-1-auto md3-surface app-pad-top-none" [hidden]="CaseSummary?.caseDetails?.isLoading">
  <div class="content grid-1-auto">
    <!--CONTENT-->
    <div class="content flex-container lh-1-15">
      <!--MAIN CONTENT & VERLAUF-->
      <div class="flex-row cols-3">
        <!--MAIN-->
        <div class="flex-col flex-col-2 app-space-top md3-card-on-surface">
          <div class="content flex-container lh-1-15">
            <!--NORMAL MODE-->
            <div *ngIf="!editMode" class="flex-row cols-4">
              <div class="flex-col"  #DivDetails>
                <h6><span>{{getResource("Case.Text")}} {{CaseSummary?.caseDetails?.data?.auNr}}</span>
                  <app-exg-dropdown>
                    <ng-template #hostTemplate>
                      <i class="md-btn-circular fal fa-ellipsis-v" [class.disabled]="!isWorkflowActive()"
                         [tooltip]="!isWorkflowActive()?'Keine Workfloweinträge verfügbar':'Workflowmenü'"
                         flow="left"></i>
                    </ng-template>
                    <ng-template #contentTemplate let-popup>
                      <div *ngFor="let row of workFlowMenu">
                        <div class="list-row list-single-line  typo-small" style="cursor: pointer" (click)="row.click()"
                             *ngIf="row.visible">{{row.caption}}</div>
                      </div>
                    </ng-template>
                  </app-exg-dropdown></h6>
                <p class="typo-small">
                  <!-- Auftragsnummer -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.auNr &&
                  CaseSummary?.caseDetails?.data?.auNr !== 0">
                    <label>{{enumSvc.getFieldCaption("Auftrag", "auNr")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.auNr}}</span>
                  </ng-container>

                  <!-- Auftragsstatus -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.au_enmIdent_AuftragStatus &&
                  CaseSummary?.caseDetails?.data?.au_enmIdent_AuftragStatus !== 0">
                    <label>{{enumSvc.getFieldCaption("Auftrag", "au_enmIdent_AuftragStatus")}}</label>
                    <span><strong>{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.au_enmName_AuftragStatus,
                      CaseSummary?.caseDetails?.data?.au_enmIdent_AuftragStatus)}}</strong></span>
                  </ng-container>

                  <!-- Auftragstyp -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.au_enmIdent_AuftragTyp &&
                  CaseSummary?.caseDetails?.data?.au_enmIdent_AuftragTyp !== 0">
                    <label>{{enumSvc.getFieldCaption("Auftrag", "au_enmIdent_AuftragTyp")}}</label>
                    <span>{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.au_enmName_AuftragTyp,
                      CaseSummary?.caseDetails?.data?.au_enmIdent_AuftragTyp)}}</span>
                  </ng-container>

                  <!--Auftraggeber-->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("Auftrag", "au_oeID_Auftraggeber")}}</label>
                    <span>
                      <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber) as OE; else isEmpty">
                        <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                      </ng-container>
                      <!--Change Button + OE is Empty-->
                      <ng-template #isEmpty>
                        {{ getResource('ChangeOE.NotAssigned') }}
                      </ng-template>
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeOE('au_oeID_Auftraggeber', '00000000-0000-0000-0000-000000000000', 4, 1)">
                        {{ getResource('change') }}
                      </a>
                      <!--Delete Button-->
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber) !== undefined
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber) !== '00000000-0000-0000-0000-000000000000'
                      " href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="deleteOE('au_oeID_Auftraggeber')">
                        {{ getResource('remove') }}
                      </a>
                    </span>
                  </ng-container>






                  <!-- Ansprechpartner -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("Auftrag", "au_oeId_Ansprechpartner")}}</label>
                    <span>
                      <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.au_oeId_Ansprechpartner) as OE; else isEmpty">
                        <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                      </ng-container>
                      <!--Change Button + OE is Empty-->
                      <ng-template #isEmpty>
                        {{ getResource('ChangeOE.NotAssigned') }}
                      </ng-template>
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeOE('au_oeId_Ansprechpartner', CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber)">
                        {{ getResource('change') }}
                      </a>
                      <!--Delete Button-->
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.au_oeId_Ansprechpartner) !== undefined
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.au_oeId_Ansprechpartner) !== '00000000-0000-0000-0000-000000000000'
                      " href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="deleteOE('au_oeId_Ansprechpartner')">
                        {{ getResource('remove') }}
                      </a>
                    </span>
                  </ng-container>
                  <!--Bearbeitungsnummer-->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.auMdtOKZ && CaseSummary?.caseDetails?.data?.auMdtOKZ?.length > 0">
                    <label>{{enumSvc.getFieldCaption("Auftrag", "auMdtOKZ")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.auMdtOKZ}}</span>
                  </ng-container>

                  <!-- Versicherungsnehmer -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_VN")}}</label>
                    <span>
                      <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_VN) as OE; else isEmpty">
                        <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                      </ng-container>
                      <!--Change Button + OE is Empty-->
                      <ng-template #isEmpty>
                        {{ getResource('ChangeOE.NotAssigned') }}
                      </ng-template>
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeOE('aue_oeID_VN')">
                        {{ getResource('change') }}
                      </a>
                      <!--Delete Button-->
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_VN) !== undefined
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_VN) !== '00000000-0000-0000-0000-000000000000'
                      " href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="deleteOE('aue_oeID_VN')">
                        {{ getResource('remove') }}
                      </a>
                    </span>
                  </ng-container>
                  <!-- Versicherungsnummer -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.auOKZ &&
                  CaseSummary?.caseDetails?.data?.auOKZ.length > 0">
                    <label>{{enumSvc.getFieldCaption("Auftrag", "auOKZ")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.auOKZ}}</span>
                  </ng-container>

                  <!-- Versicherung -->
                  <ng-container>
                    <label>
                      {{enumSvc.getFieldCaption("AuftragE_EIS","aue_oeID_Versicherung")}}
                    </label>
                    <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung ===
                    CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber
                    && CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber !== '00000000-0000-0000-0000-000000000000'
                    ; else notIdenticalVersicherung
                    ">
                      <span>{{getRessource('ChangeOE.sameAsAG')}}
                        <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                           style="color: var(--c-dark);text-decoration: none; display:inline"
                           (click)="changeOE('aue_oeID_Versicherung', '00000000-0000-0000-0000-000000000000', 4, 1)">
                          {{getResource('change')}}
                        </a>
                        <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                           style="color: var(--c-dark);text-decoration: none; display:inline"
                           (click)="deleteOE('aue_oeID_Versicherung')">
                          {{getResource('remove')}}
                        </a></span>
                    </ng-container>
                    <ng-template #notIdenticalVersicherung>
                      <span>
                        <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung) as OE; else isEmpty">
                          <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                        </ng-container>
                        <!--Change Button + OE is Empty-->
                        <ng-template #isEmpty>
                          {{ getResource('ChangeOE.NotAssigned') }}
                        </ng-template>
                        <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                           style="color: var(--c-dark);text-decoration: none; display:inline"
                           (click)="changeOE('aue_oeID_Versicherung', '00000000-0000-0000-0000-000000000000', 4, 1)">
                          {{ getResource('change') }}
                        </a>
                        <!--Delete Button-->
                        <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung) !== undefined
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung) !== '00000000-0000-0000-0000-000000000000'
                      " href="javascript:void(0)"
                           style="color: var(--c-dark);text-decoration: none; display:inline"
                           (click)="deleteOE('aue_oeID_Versicherung')">
                          {{ getResource('remove') }}
                        </a>
                      </span>
                    </ng-template>
                  </ng-container>

                  <!-- Ansprechpartner-->
                  <ng-container>
                    <label>
                      {{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_Versicherung_AnspPtnr")}}
                    </label>
                    <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung_AnspPtnr ===
                    CaseSummary?.caseDetails?.data?.au_oeId_Ansprechpartner
                    && CaseSummary?.caseDetails?.data?.au_oeId_Ansprechpartner !== '00000000-0000-0000-0000-000000000000'
                    ; else notIdenticalVersAnsprech
                    ">
                      <span>{{getRessource('ChangeOE.sameAsAG')}}
                        <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                           style="color: var(--c-dark);text-decoration: none; display:inline"
                           (click)="changeOE('aue_oeID_Versicherung_AnspPtnr', CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung)">
                          {{getResource('change')}}
                        </a>
                        <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                           style="color: var(--c-dark);text-decoration: none; display:inline"
                           (click)="deleteOE('aue_oeID_Versicherung_AnspPtnr')">
                          {{getResource('remove')}}
                        </a></span>
                    </ng-container>
                    <ng-template #notIdenticalVersAnsprech>
                      <span>
                        <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung_AnspPtnr) as OE; else isEmpty">
                          <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                        </ng-container>
                        <!--Change Button + OE is Empty-->
                        <ng-template #isEmpty>
                          {{ getResource('ChangeOE.NotAssigned') }}
                        </ng-template>
                        <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                           style="color: var(--c-dark);text-decoration: none; display:inline"
                           (click)="changeOE('aue_oeID_Versicherung_AnspPtnr', CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung)">
                          {{ getResource('change') }}
                        </a>
                        <!--Delete Button-->
                        <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung_AnspPtnr) !== undefined
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung_AnspPtnr) !== '00000000-0000-0000-0000-000000000000'
                      " href="javascript:void(0)"
                           style="color: var(--c-dark);text-decoration: none; display:inline"
                           (click)="deleteOE('aue_oeID_Versicherung_AnspPtnr')">
                          {{ getResource('remove') }}
                        </a>
                      </span>
                    </ng-template>
                  </ng-container>
                  <!-- Versicherungsart-->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aue_enmIdent_Versicherungsart &&
                  CaseSummary?.caseDetails?.data?.aue_enmIdent_Versicherungsart !== 0">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                      "aue_enmIdent_Versicherungsart")}}</label>
                    <span>{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.aue_enmName_Versicherungsart,
                      CaseSummary?.caseDetails?.data?.aue_enmIdent_Versicherungsart)}}</span>
                  </ng-container>

                  <!-- Versicherungssumme-->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueVersicherungSumme">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueVersicherungSumme")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueVersicherungSumme | excCurrency: '€'}}</span>
                  </ng-container>

                  <!-- Wert1914 -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueWert1914">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                      "aueWert1914")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueWert1914 | excCurrency: '€'}}</span>
                  </ng-container>

                  <!-- Selbstbehalt -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueSelbstbehalt">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSelbstbehalt")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueSelbstbehalt | excCurrency: '€'}}</span>
                  </ng-container>

                  <!-- Hinweise Entschädigungsgrenze -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueHinweiseEntschaedigungsgrenze">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueHinweiseEntschaedigungsgrenze")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueHinweiseEntschaedigungsgrenze}}</span>
                  </ng-container>

                  <!-- Reserve VU -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueReserveVU">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueReserveVU")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueReserveVU | excCurrency: '€'}}</span>
                  </ng-container>

                  <!-- Reserve EXCON -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueReserve">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueReserve")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueReserve | excCurrency: '€'}}</span>
                  </ng-container>

                  <!--Schadensumme -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueSchadensumme">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadensumme")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueSchadensumme | excCurrency: '€'}}</span>
                  </ng-container>

                  <!-- Regulierungssumme -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueRegulierungsumme">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueRegulierungsumme")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueRegulierungsumme | excCurrency: '€'}}</span>
                  </ng-container>

                  <!-- Einsparbetrag -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueEinsparbetrag">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueEinsparbetrag")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueEinsparbetrag | excCurrency: '€'}}</span>
                  </ng-container>

                  <!-- Leistungsgegenstand -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueLeistungsgegenstand">
                    <label>
                      {{enumSvc.getFieldCaption("AuftragE_EIS","aueLeistungsgegenstand")}}
                    </label>
                    <span>
                      <ng-container *ngFor="let v of CaseSummary?.caseDetails?.data?.aueLeistungsgegenstand.split('||'); let last = last">
                        {{enumSvc.getEnumerationText('Leistungsgegenstand', v.replaceAll('|', ''))}}
                        <ng-container *ngIf="!last"><br></ng-container>
                      </ng-container>
                    </span>

                  </ng-container>

                  <!-- Regressmöglichkeit -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueRegressmoeglichkeit_enmIdent &&
                  CaseSummary?.caseDetails?.data?.aueRegressmoeglichkeit_enmIdent !== 0">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                      "aueRegressmoeglichkeit_enmIdent")}}</label>
                    <span>{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.aueRegressmoeglichkeit_enmName,
                      CaseSummary?.caseDetails?.data?.aueRegressmoeglichkeit_enmIdent)}}</span>
                  </ng-container>
                </p>
              </div>
              <div class="flex-col"  #DivDetails2>
                <h6>
                </h6>
                <p class="typo-small">
                  <!-- Auftragsdatum -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueAuftragsdatum">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAuftragsdatum")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueAuftragsdatum | excDate}}</span>
                  </ng-container>

                  <!-- Ortstermin geplant -->
                  <ng-container
                    *ngIf="CaseSummary?.caseDetails?.data?.aueOrtsterminPlan">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtsterminPlan")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueOrtsterminPlan | excDate}}</span>
                  </ng-container>

                  <!-- Kontaktaufnahme -->
                  <ng-container
                    *ngIf="CaseSummary?.caseDetails?.data?.aueKontaktaufnahme">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueKontaktaufnahme")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueKontaktaufnahme | excDate}}</span>
                  </ng-container>

                  <!-- Ortstermin -->
                  <ng-container
                    *ngIf="CaseSummary?.caseDetails?.data?.aueOrtstermin">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtstermin")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueOrtstermin | excDate}}</span>
                  </ng-container>

                  <!-- 2.Ortstermin -->
                  <ng-container
                    *ngIf="CaseSummary?.caseDetails?.data?.aueOrtstermin2">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtstermin2")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueOrtstermin2 | excDate}}</span>
                  </ng-container>

                  <!-- Weitere Ortstermine -->
                  <ng-container
                    *ngIf="CaseSummary?.caseDetails?.data?.aueWeitereOrtstermine">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueWeitereOrtstermine")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueWeitereOrtstermine}}</span>
                  </ng-container>

                  <!-- Fristverlängerung -->
                  <ng-container
                    *ngIf="CaseSummary?.caseDetails?.data?.aueFristverlaengerungBis">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueFristverlaengerungBis")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueFristverlaengerungBis | excDate}}</span>
                  </ng-container>

                  <!-- Reklamation -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueReklamation_enmIdent &&
                  CaseSummary?.caseDetails?.data?.aueReklamation_enmIdent !== 0">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                      "aueReklamation_enmIdent")}}</label>
                    <span>{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.aueReklamation_enmName,
                      CaseSummary?.caseDetails?.data?.aueReklamation_enmIdent)}}</span>
                  </ng-container>

                  <!-- Datum Zwischenbericht -->
                  <ng-container
                    *ngIf="CaseSummary?.caseDetails?.data?.aueZwischenberichtDatum">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueZwischenberichtDatum")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueZwischenberichtDatum | excDate}}</span>
                  </ng-container>

                  <!-- Abschlussdatum -->
                  <ng-container
                    *ngIf="CaseSummary?.caseDetails?.data?.aueAbschlussdatum">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAbschlussdatum")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueAbschlussdatum | excDate}}</span>
                  </ng-container>

                  <!-- Abrechnungshinweis -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmIdent &&
                  CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmIdent !== 0">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                      "aueAbrechnungshinweis_enmIdent")}}</label>
                    <span>{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmName,
                      CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmIdent)}}</span>
                  </ng-container>

                  <!-- Abrechnungshinweis Detail -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueAbrechnungshinweisSub1_enmIdent &&
                  CaseSummary?.caseDetails?.data?.aueAbrechnungshinweisSub1_enmIdent !== 0">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                      "aueAbrechnungshinweisSub1_enmIdent")}}</label>
                    <span>{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.aueAbrechnungshinweisSub1_enmName,
                      CaseSummary?.caseDetails?.data?.aueAbrechnungshinweisSub1_enmIdent)}}</span>
                  </ng-container>

                  <!-- Belegprüfung Inklusiveleistung bis -->
                  <ng-container
                    *ngIf="CaseSummary?.caseDetails?.data?.aueAbrechnungshinweisDatum_enmIdent &&
                    CaseSummary?.caseDetails?.data?.aueAbrechnungshinweisDatum_enmIdent !== 0">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                      "aueAbrechnungshinweisDatum")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueAbrechnungshinweisDatum | excDate}}</span>
                  </ng-container>

                  <!-- Letzter Sachverständiger-->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueLetzterSachverstaendiger")}}</label>
                    <span>
                      <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterSachverstaendiger) as OE; else isEmpty">
                        <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                      </ng-container>
                      <!--Change Button + OE is Empty-->
                      <ng-template #isEmpty>
                        {{ getResource('ChangeOE.NotAssigned') }}
                      </ng-template>
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeOE('aue_oeID_letzterSachverstaendiger')">
                        {{ getResource('change') }}
                      </a>
                      <!--Delete Button-->
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterSachverstaendiger) !== undefined
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterSachverstaendiger) !== '00000000-0000-0000-0000-000000000000'
                      " href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="deleteOE('aue_oeID_letzterSachverstaendiger')">
                        {{ getResource('remove') }}
                      </a>
                    </span>
                  </ng-container>
                  <!-- Letzter QS-Prüfer -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueLetzterQSPruefer")}}</label>
                    <span>
                      <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterQSPruefer) as OE; else isEmpty">
                        <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                      </ng-container>
                      <!--Change Button + OE is Empty-->
                      <ng-template #isEmpty>
                        {{ getResource('ChangeOE.NotAssigned') }}
                      </ng-template>
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeOE('aue_oeID_letzterQSPruefer')">
                        {{ getResource('change') }}
                      </a>
                      <!--Delete Button-->
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterQSPruefer) !== undefined
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterQSPruefer) !== '00000000-0000-0000-0000-000000000000'
                      " href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="deleteOE('aue_oeID_letzterQSPruefer')">
                        {{ getResource('remove') }}
                      </a>
                    </span>
                  </ng-container>



                  <!-- Letzter Sanierungspartner-->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS","aueLetzterSanierungspartner")}}</label>
                    <span>
                      <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterSanierungspartner) as OE; else isEmpty">
                        <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                      </ng-container>
                      <!--Change Button + OE is Empty-->
                      <ng-template #isEmpty>
                        {{ getResource('ChangeOE.NotAssigned') }}
                      </ng-template>
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeOE('aue_oeID_letzterSanierungspartner', '00000000-0000-0000-0000-000000000000', 4, 1)">
                        {{ getResource('change') }}
                      </a>
                      <!--Delete Button-->
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterSanierungspartner) !== undefined
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterSanierungspartner) !== '00000000-0000-0000-0000-000000000000'
                      " href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="deleteOE('aue_oeID_letzterSanierungspartner')">
                        {{ getResource('remove') }}
                      </a>
                    </span>
                  </ng-container>


                  <!-- Schadennummer -->
                  <ng-container
                    *ngIf="CaseSummary?.caseDetails?.data?.aueSchadenNr && CaseSummary?.caseDetails?.data?.aueSchadenNr.length > 0">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenNr")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueSchadenNr}}</span>
                  </ng-container>

                  <!-- Schadendatum -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueSchadenDatum">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenDatum")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueSchadenDatum | excDate}}</span>
                  </ng-container>

                  <!-- Schadenmeldung VU -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueSchadenmeldungVU">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenmeldungVU")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.aueSchadenmeldungVU | excDate}}</span>
                  </ng-container>

                  <!-- Schadenart -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aue_enmIdent_SchadenArt &&
                  CaseSummary?.caseDetails?.data?.aue_enmIdent_SchadenArt !== 0">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                      "aue_enmIdent_SchadenArt")}}</label>
                    <span>
                      <strong>{{
                        enumSvc.getEnumerationTextA(
                          CaseSummary?.caseDetails?.data?.aue_enmName_SchadenArt, CaseSummary?.caseDetails?.data?.aue_enmIdent_SchadenArt
                        )}} ({{
                        enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.aue_enmName_SchadenArt, CaseSummary?.caseDetails?.data?.aue_enmIdent_SchadenArt
                        )}})
                      </strong>
                    </span>
                  </ng-container>

                  <!-- Schadenursache -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aue_enmIdent_SchadenUrsache &&
                  CaseSummary?.caseDetails?.data?.aue_enmIdent_SchadenUrsache !== 0">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                      "aue_enmIdent_SchadenUrsache")}}</label>
                    <span>{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.aue_enmName_SchadenUrsache,
                      CaseSummary?.caseDetails?.data?.aue_enmIdent_SchadenUrsache)}}</span>
                  </ng-container>

                  <!-- Schadenort -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueSchadenOrt">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenOrt")}}</label>
                    <span>
                      <ng-container *ngIf="CaseSummary?.Schadenort?.data as address">
                        <em>{{address.adrStr}} {{address.adrHNum}} </em>
                        <em>{{address.adrPlz}} {{address.adrOrt}}</em>
                      </ng-container>
                      <br/>
                    </span>
                  </ng-container>

                  <!-- Ansprechpartner -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS","aue_oeID_AnspPtnr")}}</label>
                    <span>
                      <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) as OE; else isEmpty">
                        <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                      </ng-container>
                      <!--Change Button + OE is Empty-->
                      <ng-template #isEmpty>
                        {{ getResource('ChangeOE.NotAssigned') }}
                      </ng-template>
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeOE('aue_oeID_AnspPtnr')">
                        {{ getResource('change') }}
                      </a>
                      <!--Delete Button-->
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) !== undefined
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) !== '00000000-0000-0000-0000-000000000000'
                      " href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="deleteOE('aue_oeID_AnspPtnr')">
                        {{ getResource('remove') }}
                      </a>
                    </span>
                  </ng-container>

                  <!-- Anspruchsteller-->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS","aueAnspruchsteller")}}</label>
                    <span>
                      <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Anspruchsteller) as OE; else isEmpty">
                        <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                      </ng-container>
                      <!--Change Button + OE is Empty-->
                      <ng-template #isEmpty>
                        {{ getResource('ChangeOE.NotAssigned') }}
                      </ng-template>
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeOE('aue_oeID_Anspruchsteller')">
                        {{ getResource('change') }}
                      </a>
                      <!--Delete Button-->
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Anspruchsteller) !== undefined
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Anspruchsteller) !== '00000000-0000-0000-0000-000000000000'
                      " href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="deleteOE('aue_oeID_Anspruchsteller')">
                        {{ getResource('remove') }}
                      </a>
                    </span>
                  </ng-container>



                  <!-- Weiterer Ansprechpartner 1-->
                  <ng-container>
                    <label>{{ enumSvc.getEnumerationText(
                      CaseSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion,
                      CaseSummary?.caseDetails?.data?.aue_enmIdent_WAnsprPtnr1Funktion)
                      }}</label>
                    <span>
                      <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr1) as OE; else isEmpty">
                        <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                      </ng-container>
                      <!--Change Button + OE is Empty-->
                      <ng-template #isEmpty>
                        {{ getResource('ChangeOE.NotAssigned') }}
                      </ng-template>
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeOE('aue_oeID_WAnsprPtnr1')">
                        {{ getResource('change') }}
                      </a>
                      <!--Delete Button-->
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr1) !== undefined
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr1) !== '00000000-0000-0000-0000-000000000000'
                      " href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="deleteOE('aue_oeID_WAnsprPtnr1')">
                        {{ getResource('remove') }}
                      </a>
                    </span>
                  </ng-container>
                  <!-- Weiterer Ansprechpartner 2 -->
                  <ng-container>
                    <label>{{ enumSvc.getEnumerationText(
                      CaseSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion,
                      CaseSummary?.caseDetails?.data?.aue_enmIdent_WAnsprPtnr2Funktion)
                      }}</label>
                    <span>
                      <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr2) as OE; else isEmpty">
                        <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                      </ng-container>
                      <!--Change Button + OE is Empty-->
                      <ng-template #isEmpty>
                        {{ getResource('ChangeOE.NotAssigned') }}
                      </ng-template>
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeOE('aue_oeID_WAnsprPtnr2')">
                        {{ getResource('change') }}
                      </a>
                      <!--Delete Button-->
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr2) !== undefined
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr2) !== '00000000-0000-0000-0000-000000000000'
                      " href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="deleteOE('aue_oeID_WAnsprPtnr2')">
                        {{ getResource('remove') }}
                      </a>
                    </span>
                  </ng-container>
                  <!-- Weiterer Ansprechpartner 3 -->
                  <ng-container>
                    <label>{{ enumSvc.getEnumerationText(
                      CaseSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion,
                      CaseSummary?.caseDetails?.data?.aue_enmIdent_WAnsprPtnr3Funktion)
                      }}</label>
                    <span>
                      <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr3) as OE; else isEmpty">
                        <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                      </ng-container>
                      <!--Change Button + OE is Empty-->
                      <ng-template #isEmpty>
                        {{ getResource('ChangeOE.NotAssigned') }}
                      </ng-template>
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeOE('aue_oeID_WAnsprPtnr3')">
                        {{ getResource('change') }}
                      </a>
                      <!--Delete Button-->
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr3) !== undefined
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr3) !== '00000000-0000-0000-0000-000000000000'
                      " href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="deleteOE('aue_oeID_WAnsprPtnr3')">
                        {{ getResource('remove') }}
                      </a>
                    </span>
                  </ng-container>
                  <!-- Weiterer Ansprechpartner 4 -->
                  <ng-container>
                    <label>{{ enumSvc.getEnumerationText(
                      CaseSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion,
                      CaseSummary?.caseDetails?.data?.aue_enmIdent_WAnsprPtnr4Funktion)
                      }}</label>
                    <span>
                      <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr4) as OE; else isEmpty">
                        <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                      </ng-container>
                      <!--Change Button + OE is Empty-->
                      <ng-template #isEmpty>
                        {{ getResource('ChangeOE.NotAssigned') }}
                      </ng-template>
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeOE('aue_oeID_WAnsprPtnr4')">
                        {{ getResource('change') }}
                      </a>
                      <!--Delete Button-->
                      <a *ngIf="excSecurity.isFeatured('CASEEDIT')
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr4) !== undefined
                      && config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr4) !== '00000000-0000-0000-0000-000000000000'
                      " href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="deleteOE('aue_oeID_WAnsprPtnr4')">
                        {{ getResource('remove') }}
                      </a>
                    </span>
                  </ng-container>
                </p>
              </div>
            </div>
            <!--EDIT MODE-->
            <div *ngIf="editMode" class="flex-row cols-4">
              <div class="flex-col"  #DivDetails>
                <h6><span>{{getResource("Case.Text")}} {{CaseSummary?.caseDetails?.data?.auNr}}</span>
                  <app-exg-dropdown>
                    <ng-template #hostTemplate>
                      <i class="md-btn-circular fal fa-ellipsis-v" *ngIf="!editMode"
                         [class.disabled]="!isWorkflowActive()"
                         [tooltip]="!isWorkflowActive()?'Keine Workfloweinträge verfügbar':'Workflowmenü'"
                         flow="left"></i>
                    </ng-template>
                    <ng-template #contentTemplate let-popup>
                      <div *ngFor="let row of workFlowMenu">
                        <div class="list-row list-single-line  typo-small" style="cursor: pointer" (click)="row.click()"
                             *ngIf="row.visible">{{row.caption}}</div>
                      </div>
                    </ng-template>
                  </app-exg-dropdown></h6>
                <p class="typo-small">

                  <!-- Auftragsnummer -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.auNr &&
                  CaseSummary?.caseDetails?.data?.auNr !== 0">
                    <label>{{enumSvc.getFieldCaption("Auftrag", "auNr")}}</label>
                    <span>{{CaseSummary?.caseDetails?.data?.auNr}}</span>
                  </ng-container>

                  <!-- Auftragsstatus -->
                  <!--<ng-container *ngIf="CaseSummary?.caseDetails?.data?.au_enmIdent_AuftragStatus &&
                  CaseSummary?.caseDetails?.data?.au_enmIdent_AuftragStatus !== 0">
                    <label>{{enumSvc.getFieldCaption("Auftrag", "au_enmIdent_AuftragStatus")}}</label>
                    <span><strong>
                      <app-exg-dropdown class="app-edit-case-workspace-nospace"
                                        [list]="enumSvc.getEnumerationList('AuftragStatus')" listdisplay="enmText"
                                        label="{{enumSvc.getEnumerationText
                                        (CaseSummary?.caseDetails?.data?.au_enmName_AuftragStatus,
                                        CaseSummary?.caseDetails?.data?.au_enmIdent_AuftragStatus)}}"
                                        maxHeight="250px" position="abovecenter" (change)="change($event)">
                      </app-exg-dropdown>
                    </strong></span>
                  </ng-container>-->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.au_enmIdent_AuftragStatus &&
                  CaseSummary?.caseDetails?.data?.au_enmIdent_AuftragStatus !== 0">
                    <label>{{enumSvc.getFieldCaption("Auftrag", "au_enmIdent_AuftragStatus")}}</label>
                    <span><strong>{{enumSvc.getEnumerationText(CaseSummary?.caseDetails?.data?.au_enmName_AuftragStatus,
                      CaseSummary?.caseDetails?.data?.au_enmIdent_AuftragStatus)}}</strong></span>
                  </ng-container>

                  <!-- Auftragstyp -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("Auftrag", "au_enmIdent_AuftragTyp")}}</label>
                    <span>
                      <app-exg-dropdown class="app-edit-case-workspace-nospace"
                                        [list]="enumSvc.getEnumerationList('AuftragTyp')" listdisplay="enmText"
                                        label="{{enumSvc.getEnumerationText
                                        (CaseSummary?.caseDetails?.data?.au_enmName_AuftragTyp,
                                        this.uiModel.au_enmIdent_AuftragTyp)}}"
                                        maxHeight="250px" position="abovecenter" (change)="changeEnum($event)">
                      </app-exg-dropdown>
                    </span>
                  </ng-container>

                  <!--Auftraggeber-->
                  <ng-container
                    *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber) as OE">
                    <label>{{enumSvc.getFieldCaption("Auftrag", "au_oeID_Auftraggeber")}}</label>
                    <span>
                      <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                    </span>
                  </ng-container>

                  <!-- Ansprechpartner -->
                  <ng-container
                    *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.au_oeId_Ansprechpartner) as OE">
                    <label>{{enumSvc.getFieldCaption("Auftrag", "au_oeId_Ansprechpartner")}}</label>
                    <span>
                      <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                    </span>
                  </ng-container>

                  <!--Bearbeitungsnummer-->
                  <label>{{enumSvc.getFieldCaption("Auftrag", "auMdtOKZ")}}</label>
                  <span>
                    <exg-input class="app-edit-case-workspace-nospace"
                               type="text" [(ngModel)]="uiModel.auMdtOKZ"
                               [caption]="' '"
                               name="auMdtOKZ">
                    </exg-input>
                  </span>

                  <!-- Versicherungsnehmer -->
                  <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_VN) as OE">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_VN")}}</label>
                    <span>
                      <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                    </span>
                  </ng-container>

                  <!-- Versicherungsnummer -->
                  <label>{{enumSvc.getFieldCaption("Auftrag", "auOKZ")}}</label>
                  <span>
                    <exg-input class="app-edit-case-workspace-nospace"
                               type="text" [(ngModel)]="uiModel.auOKZ"
                               [caption]="' '"
                               name="auOKZ">
                    </exg-input>
                  </span>

                  <!-- Versicherung -->
                  <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung) as OE">
                    <label>
                      {{enumSvc.getFieldCaption("AuftragE_EIS","aue_oeID_Versicherung")}}
                    </label>
                    <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung ===
                    CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber">
                      <span>{{getRessource('ChangeOE.sameAsAG')}}</span>
                    </ng-container>
                    <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung !==
                    CaseSummary?.caseDetails?.data?.au_oeID_Auftraggeber">
                      <span>
                        <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                      </span>
                    </ng-container>
                  </ng-container>

                  <!-- Ansprechpartner -->
                  <ng-container
                    *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung_AnspPtnr) as OE">
                    <label>
                      {{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_Versicherung_AnspPtnr")}}
                    </label>
                    <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung_AnspPtnr ===
                    CaseSummary?.caseDetails?.data?.au_oeId_Ansprechpartner">
                      <span>{{getRessource('ChangeOE.sameAsAG')}}</span>
                    </ng-container>
                    <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aue_oeID_Versicherung_AnspPtnr !==
                    CaseSummary?.caseDetails?.data?.au_oeId_Ansprechpartner">
                      <span>
                        <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                      </span>
                    </ng-container>
                  </ng-container>

                  <!-- Versicherungsart-->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                      "aue_enmIdent_Versicherungsart")}}</label>
                    <span>
                      <app-exg-dropdown class="app-edit-case-workspace-nospace"
                                        [list]="enumSvc.getEnumerationList('Versicherungsart')" listdisplay="enmText"
                                        label="{{enumSvc.getEnumerationText
                                        (CaseSummary?.caseDetails?.data?.aue_enmName_Versicherungsart,
                                        uiModel.aue_enmIdent_Versicherungsart)}}"
                                        maxHeight="250px" position="abovecenter" (change)="changeEnum($event)">
                      </app-exg-dropdown>
                    </span>
                  </ng-container>

                  <!-- Versicherungssumme-->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueVersicherungSumme")}}</label>
                    <span>
                      {{uiModel.aueWert1914 * CaseSummary?.wert1914Faktor?.data | excCurrency: '€'}}
                    </span>
                  </ng-container>

                  <!-- Wert1914 -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS","aueWert1914")}}</label>
                    <span>
                      <exg-input class="app-edit-case-workspace-nospace app-hide-empty"
                                 type="money" [(ngModel)]=uiModel.aueWert1914
                                 [caption]="' '"
                                 name="aueWert1914">
                      </exg-input>
                    </span>
                  </ng-container>

                  <!-- Selbstbehalt -->
                  <label>{{enumSvc.getFieldCaption("AuftragE_EIS","aueSelbstbehalt")}}</label>
                  <span>
                    <exg-input class="app-edit-case-workspace-nospace app-hide-empty"
                               type="money"
                               [(ngModel)]="uiModel.aueSelbstbehalt"
                               [caption]="' '"
                               name="aueSelbstbehalt">
                    </exg-input>
                  </span>

                  <!-- Hinweise Entschädigungsgrenze -->
                  <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueHinweiseEntschaedigungsgrenze")}}</label>
                  <span>
                    <exg-textarea class="app-edit-case-workspace-nospace app-hide-empty"
                                  type="text" [(ngModel)]="uiModel.aueHinweiseEntschaedigungsgrenze"

                                  [maxlength]="4096"
                                  name="aueHinweiseEntschaedigungsgrenze">
                    </exg-textarea>
                  </span>

                  <!-- Reserve VU -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueReserveVU")}}</label>
                    <span>
                      <exg-input class="app-edit-case-workspace-nospace app-hide-empty"
                                 type="money" [(ngModel)]=uiModel.aueReserveVU
                                 [caption]="' '"
                                 name="aueReserveVU">
                      </exg-input>
                    </span>
                  </ng-container>

                  <!-- Reserve EXCON -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueReserve")}}</label>
                    <span>
                      <exg-input class="app-edit-case-workspace-nospace app-hide-empty"
                                 [(ngModel)]="uiModel.aueReserve"
                                 [caption]="' '"
                                 name="aueReserve"
                                 type="money">
                      </exg-input>
                    </span>
                  </ng-container>

                  <!--Schadensumme -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadensumme")}}</label>
                    <span>
                      <exg-input class="app-edit-case-workspace-nospace app-hide-empty"
                                 type="money" [(ngModel)]=uiModel.aueSchadensumme
                                 [caption]="' '"
                                 name="aueSchadensumme">
                      </exg-input>
                    </span>
                  </ng-container>

                  <!-- Regulierungssumme -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueRegulierungsumme")}}</label>
                    <span>
                      <exg-input class="app-edit-case-workspace-nospace app-hide-empty"
                                 type="money" [(ngModel)]=uiModel.aueRegulierungsumme
                                 [caption]="' '"
                                 name="aueRegulierungsumme">
                      </exg-input>
                    </span>
                  </ng-container>

                  <!-- Einsparbetrag -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueEinsparbetrag")}}</label>
                    <span>
                      <exg-input class="app-edit-case-workspace-nospace app-hide-empty"
                                 type="money"
                                 [(ngModel)]=uiModel.aueEinsparbetrag
                                 [caption]="' '"
                                 name="aueEinsparbetrag">
                      </exg-input>
                    </span>
                  </ng-container>

                  <!-- Leistungsgegenstand -->
                  <ng-container>
                    <label>
                      {{enumSvc.getFieldCaption("AuftragE_EIS","aueLeistungsgegenstand")}}
                    </label>
                    <ng-container>
                      <!--Leistungsgegenstand-->
                      <ng-container *ngFor="let enm of aueLeistungsgegenstandEnmList">
                        <exg-switch [(ngModel)]="enm.enmValue"
                                    (ngModelChange)="computeAueLeistungsgegenstand()"
                                    caption="{{enm.enmText}}"
                                    class=""
                                    [style.font-weight]="'normal'">
                        </exg-switch>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <!-- Regressmöglichkeit -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                      "aueRegressmoeglichkeit_enmIdent")}}</label>
                    <span>
                      <app-exg-dropdown class="app-edit-case-workspace-nospace"
                                        [list]="enumSvc.getEnumerationList('Regressmoeglichkeit')" listdisplay="enmText"
                                        label="{{enumSvc.getEnumerationText(
                                        CaseSummary?.caseDetails?.data?.aueRegressmoeglichkeit_enmName,
                                        uiModel.aueRegressmoeglichkeit_enmIdent)}}"
                                        maxHeight="250px" position="abovecenter" (change)="changeEnum($event)">
                      </app-exg-dropdown>
                    </span>
                  </ng-container>
                </p>
              </div>
              <div class="flex-col"  #DivDetails2>
                <h6>
                </h6>
                <p class="typo-small">

                  <!-- Auftragsdatum -->
                  <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAuftragsdatum")}}</label>
                  <span>
                    <exg-input class="app-edit-case-workspace-nospace"
                               [(ngModel)]="uiModel.aueAuftragsdatum"
                               name="aueAuftragsdatum"
                               type="date" [isEpoch]="true">
                    </exg-input>
                  </span>

                  <!-- Ortstermin geplant -->
                  <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtsterminPlan")}}</label>
                  <span>
                    <exg-input class="app-edit-case-workspace-nospace"
                               [(ngModel)]="uiModel.aueOrtsterminPlan"
                               name="aueOrtsterminPlan"
                               type="date" [isEpoch]="true">
                    </exg-input>
                  </span>

                  <!-- Kontaktaufnahme -->
                  <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueKontaktaufnahme")}}</label>
                  <span>
                    <exg-input class="app-edit-case-workspace-nospace"
                               [(ngModel)]="uiModel.aueKontaktaufnahme"
                               name="aueKontaktaufnahme"
                               type="date" [isEpoch]="true">
                    </exg-input>
                  </span>

                  <!-- Ortstermin -->
                  <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtstermin")}}</label>
                  <span>
                    <exg-input class="app-edit-case-workspace-nospace"
                               [(ngModel)]="uiModel.aueOrtstermin"
                               name="aueOrtstermin"
                               type="date" [isEpoch]="true">
                    </exg-input>
                  </span>

                  <!-- 2.Ortstermin -->
                  <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueOrtstermin2")}}</label>
                  <span>
                    <exg-input class="app-edit-case-workspace-nospace"
                               [(ngModel)]="uiModel.aueOrtstermin2"
                               name="aueOrtstermin2"
                               type="date" [isEpoch]="true">
                    </exg-input>
                  </span>

                  <!-- Weitere Ortstermine -->
                  <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueWeitereOrtstermine")}}</label>
                  <span>
                    <exg-input class="app-edit-case-workspace-nospace app-hide-empty"
                               [(ngModel)]="uiModel.aueWeitereOrtstermine"
                               [caption]="uiModel.aueWeitereOrtstermine ? '' :
                                 enumSvc.getFieldCaption('AuftragE_EIS', 'aueWeitereOrtstermine')"
                               [maxlength]="2048"
                               name="aueWeitereOrtstermine"
                               type="text">
                    </exg-input>
                  </span>

                  <!-- Fristverlängerung -->
                  <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueFristverlaengerungBis")}}</label>
                  <span>
                    <exg-input class="app-edit-case-workspace-nospace"
                               [(ngModel)]="uiModel.aueFristverlaengerungBis"
                               name="aueFristverlaengerungBis"
                               type="date" [isEpoch]="true">
                    </exg-input>
                  </span>

                  <!-- Reklamation -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                      "aueReklamation_enmIdent")}}</label>
                    <span>
                      <app-exg-dropdown class="app-edit-case-workspace-nospace"
                                        [list]="enumSvc.getEnumerationList('Reklamation')" listdisplay="enmText"
                                        label="{{enumSvc.getEnumerationText(
                                        CaseSummary?.caseDetails?.data?.aueReklamation_enmName,
                                        uiModel.aueReklamation_enmIdent)}}"
                                        maxHeight="250px" position="abovecenter" (change)="changeEnum($event)">
                      </app-exg-dropdown>
                    </span>
                  </ng-container>

                  <!-- Datum Zwischenbericht -->
                  <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueZwischenberichtDatum")}}</label>
                  <span>
                    <exg-input class="app-edit-case-workspace-nospace"
                               [(ngModel)]="uiModel.aueZwischenberichtDatum"
                               name="aueZwischenberichtDatum"
                               type="date" [isEpoch]="true">
                    </exg-input>
                  </span>

                  <!-- Abschlussdatum -->
                  <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAbschlussdatum")}}</label>
                  <span>
                    <exg-input class="app-edit-case-workspace-nospace"
                               [(ngModel)]="uiModel.aueAbschlussdatum"
                               name="aueAbschlussdatum"
                               type="date" [isEpoch]="true">
                    </exg-input>
                  </span>

                  <!-- Abrechnungshinweis -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                      "aueAbrechnungshinweis_enmIdent")}}</label>
                    <span>
                      <app-exg-dropdown class="app-edit-case-workspace-nospace"
                                        [list]="enumSvc.getEnumerationList('Abrechnungshinweis')" listdisplay="enmText"
                                        label="{{enumSvc.getEnumerationText(
                                        CaseSummary?.caseDetails?.data?.aueAbrechnungshinweis_enmName,
                                        uiModel.aueAbrechnungshinweis_enmIdent)}}"
                                        maxHeight="250px" position="abovecenter" (change)="changeEnum($event)">
                      </app-exg-dropdown>
                    </span>
                  </ng-container>

                  <!-- Abrechnungshinweis Detail -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                      "aueAbrechnungshinweisSub1_enmIdent")}}</label>
                    <span>
                      <app-exg-dropdown class="app-edit-case-workspace-nospace"
                                        [list]="enumSvc.getEnumerationList('AbrechnungshinweisPauschal')"
                                        listdisplay="enmText"
                                        label="{{enumSvc.getEnumerationText(
                                        'AbrechnungshinweisPauschal',uiModel.aueAbrechnungshinweisSub1_enmIdent)}}"
                                        maxHeight="250px" position="abovecenter" (change)="changeEnum($event)">
                      </app-exg-dropdown>
                    </span>
                  </ng-container>

                  <!-- Belegprüfung Inklusiveleistung bis -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                      "aueAbrechnungshinweisDatum")}}</label>
                    <span>
                      <exg-input class="app-edit-case-workspace-nospace"
                                 [(ngModel)]="uiModel.aueAbrechnungshinweisDatum"
                                 name="aueAbrechnungshinweisDatum"
                                 type="date" [isEpoch]="true">
                      </exg-input>
                    </span>
                  </ng-container>

                  <!-- Letzter Sachverständiger -->
                  <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterSachverstaendiger) as OE">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueLetzterSachverstaendiger")}}</label>
                    <span>
                      <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                    </span>
                  </ng-container>

                  <!-- Letzter QS-Prüfer -->
                  <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterQSPruefer) as OE">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueLetzterQSPruefer")}}</label>
                    <span>
                      <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                      <a *ngIf="excSecurity.isFeatured('TASKDISPO')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeLastQSAuditor()">
                        {{getResource('change')}}
                      </a>
                    </span>
                  </ng-container>

                  <!-- Letzter Sanierungspartner -->
                  <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_letzterSanierungspartner) as OE">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS","aueLetzterSanierungspartner")}}</label>
                    <span>
                      <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                    </span>
                  </ng-container>

                  <!-- Schadennummer -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenNr")}}</label>
                    <span>
                      <exg-input class="app-edit-case-workspace-nospace app-hide-empty"
                                 [(ngModel)]="uiModel.aueSchadenNr"
                                 [caption]="uiModel.aueSchadenNr ? '' :
                                 enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenNr')"
                                 [maxlength]="64"
                                 name="aueSchadenNr"
                                 type="text">
                      </exg-input>
                    </span>
                  </ng-container>

                  <!-- Schadendatum -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenDatum")}}</label>
                    <span>
                      <exg-input class="app-edit-case-workspace-nospace"
                                 [(ngModel)]="uiModel.aueSchadenDatum"
                                 name="aueSchadenDatum"
                                 type="date" [isEpoch]="true">
                      </exg-input>
                    </span>
                  </ng-container>

                  <!-- Schadenmeldung VU -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenmeldungVU")}}</label>
                    <span>
                      <exg-input class="app-edit-case-workspace-nospace"
                                 [(ngModel)]="uiModel.aueSchadenmeldungVU"
                                 name="aueSchadenmeldungVU"
                                 type="date" [isEpoch]="true">
                      </exg-input>
                    </span>
                  </ng-container>

                  <!-- Schadenart -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS","aue_enmIdent_SchadenArt")}}</label>
                    <span>
                      <app-exg-dropdown class="app-edit-case-workspace-nospace"
                                        [list]="enumSvc.getEnumerationList('Schadenart')" listdisplay="enmText"
                                        label="{{enumSvc.getEnumerationTextA(
                                        CaseSummary?.caseDetails?.data?.aue_enmName_SchadenArt,
                                        uiModel.aue_enmIdent_SchadenArt)}}"
                                        maxHeight="250px" position="abovecenter" (change)="changeEnum($event)">
                      </app-exg-dropdown>
                    </span>
                  </ng-container>

                  <!-- Schadenursache -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS","aue_enmIdent_SchadenUrsache")}}</label>
                    <span>
                      <app-exg-dropdown class="app-edit-case-workspace-nospace"
                                        [list]="enumSvc.getEnumerationList(
                                        CaseSummary?.caseDetails?.data?.aue_enmName_SchadenUrsache)"
                                        listdisplay="enmText"
                                        label="{{enumSvc.getEnumerationText(
                                        CaseSummary?.caseDetails?.data?.aue_enmName_SchadenUrsache,
                                        uiModel.aue_enmIdent_SchadenUrsache)}}"
                                        maxHeight="250px" position="abovecenter" (change)="changeEnum($event)">
                      </app-exg-dropdown>
                    </span>
                  </ng-container>

                  <!-- Schadenort -->
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aueSchadenOrt">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenOrt")}}</label>
                    <span>
                      <ng-container *ngIf="CaseSummary?.Schadenort?.data as address">
                        <em>{{address.adrStr}} {{address.adrHNum}} </em>
                        <em>{{address.adrPlz}} {{address.adrOrt}}</em>
                      </ng-container>
                      <br/>
                    </span>
                  </ng-container>

                  <!-- Ansprechpartner -->
                  <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) as OE">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_AnspPtnr")}}</label>
                    <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aue_oeID_VN === CaseSummary?.caseDetails?.data?.aue_oeID_AnspPtnr">
                      <span>{{getRessource('ChangeOE.sameAsVN')}}</span>
                    </ng-container>
                    <ng-container *ngIf="CaseSummary?.caseDetails?.data?.aue_oeID_VN !== CaseSummary?.caseDetails?.data?.aue_oeID_AnspPtnr">
                      <span>
                        <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                      </span>
                    </ng-container>
                  </ng-container>

                  <!-- Anspruchsteller -->
                  <ng-container
                    *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_Anspruchsteller) as OE">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS","aueAnspruchsteller")}}</label>
                    <span>
                      <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                    </span>
                  </ng-container>
                  <!-- Weiterer Ansprechpartner 1 -->
                  <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr1) as OE">
                    <label>{{enumSvc.getEnumerationText(
                      CaseSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion,
                      CaseSummary?.caseDetails?.data?.aue_enmIdent_WAnsprPtnr1Funktion)
                      }} </label>
                    <span>
                      <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                    </span>
                  </ng-container>
                  <!-- Weiterer Ansprechpartner 2 -->
                  <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr2) as OE">
                    <label>{{enumSvc.getEnumerationText(
                      CaseSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion,
                      CaseSummary?.caseDetails?.data?.aue_enmIdent_WAnsprPtnr2Funktion)
                      }} </label>
                    <span>
                      <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                    </span>
                  </ng-container>
                  <!-- Weiterer Ansprechpartner 3 -->
                  <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr3) as OE">
                    <label>{{enumSvc.getEnumerationText(
                      CaseSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion,
                      CaseSummary?.caseDetails?.data?.aue_enmIdent_WAnsprPtnr3Funktion)
                      }} </label>
                    <span>
                      <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                    </span>
                  </ng-container>
                  <!-- Weiterer Ansprechpartner 4 -->
                  <ng-container *ngIf="config.getOEByID(CaseSummary?.caseDetails?.data?.aue_oeID_WAnsprPtnr4) as OE">
                    <label>{{enumSvc.getEnumerationText(
                      CaseSummary?.caseDetails?.data?.aue_enmName_WAnsprPtnrFunktion,
                      CaseSummary?.caseDetails?.data?.aue_enmIdent_WAnsprPtnr4Funktion)
                      }} </label>
                    <span>
                      <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                    </span>
                  </ng-container>

                </p>
              </div>
            </div>
          </div>
        </div>
        <!--VERLAUF-->
        <div class="flex-col app-space-top md3-card-on-surface layout-auto-1" #DivVerlauf style="min-height: 360px">
          <h6>
            {{getResource('Tabs.Progress.HeaderText')}}
          </h6>
          <ng-container *ngIf="resized">
            <div class="content app-space_025">
              <exg-data-list [allowSingleSelection]="false"
                             [displayState]="config.flowTable.state"
                             [rowSource]="CaseSummary?.flowTable.data"
                             selectKey="lnkID" >
                <ng-template #rowTemplate let-row>
                  <div class="list-row list-single-line grid-auto-1">
                    <div class="list-avatar nobackground row-span-2" style="cursor: pointer"
                         (click)="config.openLink(row)"><i
                      class="{{getTranslation('Icons.' + row.lnkTable)}}"></i></div>
                    <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                      <div class="list-metadata" style="margin-left:0">
                        <span style="padding-right: 0.25rem">{{row.Etikett}}</span>
                        <span style="letter-spacing: 0.25rem">
                          <ng-container *ngIf="row.Etikett === 'Nachricht'">
                            <i class="fal fa-inbox-in" *ngIf="row.lnkImageUrl.indexOf('In')>-1"></i>
                            <i class="fal fa-inbox-out" *ngIf="row.lnkImageUrl.indexOf('Out')>-1"></i>
                            <i class="fal fa-paperclip" *ngIf="row.lnkImageUrl.indexOf('Anhang')>-1"></i>
                            <i class="fal fa-check" *ngIf="row.lnkImageUrl.indexOf('Done')>-1"></i>
                            <i class="fal fa-location" *ngIf="row.lnkImageUrl.indexOf('EXAKT')>-1"></i>
                          </ng-container>
                          <ng-container *ngIf="row.Etikett === 'Aufgabe'">
                            <i class="fal fa-check" *ngIf="row.lnkImageUrl.indexOf('Done')>-1"></i>
                          </ng-container>
                        </span>
                      </div>
                      <div class="list-metadata">
                        <div
                          class="typo-right">{{row.lnkCRD | excDate: 'Globals.DateTimeFormatShort'}}</div>
                        <div class="typo-right">{{row.lnkCRU}}</div>
                      </div>
                      <div class="span-2"><strong>{{row.lnkName}}</strong></div>
                      <div class="span-2 list-secondary-text"></div>
                    </div>
                  </div>
                </ng-template>
              </exg-data-list>
            </div>
          </ng-container>
          <ng-container *ngIf="!resized">
            <div class="content">
              <div class="splash loading">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <!--BESCHREIBUNG BILD ETC.-->
      <div class="flex-row app-space-top cols-3">
        <div class="flex-col md3-card-on-surface">
          <div class="content flex-container lh-1-15">
            <div class="flex-row cols-3">
              <div class="flex-col app-space-top">
                <p class="typo-small">
                  <label>{{enumSvc.getFieldCaption("Auftrag", "auBeschreibung")}}</label>
                  <ng-container *ngIf="!CaseSummary?.caseDetails?.data?.auBeschreibung && !editMode">
                    <span style="white-space: pre-wrap">keine Beschreibung vorhanden</span>
                  </ng-container>
                  <ng-container *ngIf="CaseSummary?.caseDetails?.data?.auBeschreibung && !editMode">
                    <span style="white-space: pre-wrap">{{CaseSummary?.caseDetails?.data?.auBeschreibung}}</span>
                  </ng-container>
                  <ng-container *ngIf="editMode">
                    <exg-textarea class="app-edit-case-workspace-nospace"
                                  [(ngModel)]="uiModel.auBeschreibung"
                                  [maxlength]="4096"
                                  type="text" name="auBeschreibung">
                    </exg-textarea>
                  </ng-container>
                </p>
              </div>
              <div class="flex-col app-space-top">
                <p class="typo-small">
                  <!-- Objektbild -->
                  <ng-container>
                    <label>Objektbild</label>
                    <span>
                      <img alt="thumb"
                           [ngClass]="{'placeholder-img': (!CaseSummary?.caseDetails?.data?.aueObjektbild_dokID || CaseSummary?.caseDetails?.data?.aueObjektbild_dokID === '00000000-0000-0000-0000-000000000000')}"
                           src="{{(!CaseSummary?.caseDetails?.data?.aueObjektbild_dokID || CaseSummary?.caseDetails?.data?.aueObjektbild_dokID === '00000000-0000-0000-0000-000000000000')
                                   ? 'assets/images/NoImage.png'
                                   : excRest.computeUrl('ImageThumbnailBig',
                                          {thumb: 120, dokID: CaseSummary?.caseDetails?.data?.aueObjektbild_dokID})}}"
                           (click)="showObjectImageUpdateModal()"/>
                    </span>
                  </ng-container>
                </p>
              </div>
              <div class="flex-col">
              </div>
            </div>
            <div class="flex-row cols-3">
              <div class="flex-col">
                <p class="typo-small">
                  <!-- CRD -->
                  <label>{{enumSvc.getFieldCaption("All", '%CRD')}}</label>
                  <span>
                    {{CaseSummary?.caseDetails?.data?.auCRD | excDate: getGlobal('DateFormat')}} ({{CaseSummary?.caseDetails?.data?.auCRU}})
                  </span>

                  <!-- LCD -->
                  <label>{{enumSvc.getFieldCaption("All", '%LCD')}}</label>
                  <span>
                    {{CaseSummary?.caseDetails?.data?.auLCD | excDate: getGlobal('DateFormat')}} ({{CaseSummary?.caseDetails?.data?.auLCU}})
                  </span>
                </p>
              </div>
              <div class="flex-col">
                <p class="typo-small">
                  <!-- Letzter historisierter Eintrag -->
                  <label>Letzter historisierter Eintrag</label>
                  <span *ngIf="CaseSummary?.historyTable?.data[0]">
                    {{CaseSummary?.historyTable?.data[0]?.lnkCRD | excDate: getGlobal('DateTimeFormatShort')}} ({{CaseSummary?.historyTable?.data[0]?.lnkCRU}})
                  </span>
                  <span *ngIf="!CaseSummary?.historyTable?.data[0]">
                    Kein Eintrag vorhanden
                  </span>
                </p>
              </div>
              <div class="flex-col">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--ABLAUFPLAN-->
      <div class="flex-row md3-card-on-surface app-space-top"
           *ngIf="excSecurity.isFeatured('SCHEDULEREAD')">
        <div class="flex-col app-space-bottom_1">
          <div class="grid-1-auto">
            <h6>{{getResource("Schedule.Text")}} </h6>
            <button [disabled]="!excSecurity.isFeatured('SCHEDULECREATE')"
                    class="md-btn" (click)="createSchedule()">
              Ablaufpunkt erstellen
            </button>
          </div>
          <ng-container *ngIf="!CaseSummary?.workList?.data || CaseSummary?.workList?.isEmpty">
            <p>Es wurde noch kein Ablaufplan erstellt.</p>
          </ng-container>
          <ng-container *ngIf="CaseSummary?.workList?.data && !CaseSummary?.workList?.isEmpty">
            <div class="app-subarea" style="margin:0 1rem">
              <exg-data-table #VCAP
                              [allowSingleSelection]="false" [displayState]="0"
                              [rowSource]="CaseSummary?.workList?.data"
                              selectKey="apiID"
                              containerClass="grid cols-24"
                              (RowDblClick)="updateSchedule($event)">
                <ng-template #headerTemplate>
                  <div class="span-3">
                    #
                  </div>
                  <div class="span-5">
                    {{enumSvc.getFieldCaption("Ablaufplan", "apiBezeichnung")}}
                  </div>
                  <div class="span-3">
                    {{enumSvc.getFieldCaption("Ablaufplan", "apiSollDatum")}}
                  </div>
                  <div class="span-3">
                    {{enumSvc.getFieldCaption("Ablaufplan", "apiPlanDatum")}}
                  </div>
                  <div class="span-3">
                    {{enumSvc.getFieldCaption("Ablaufplan", "apiIstDatum")}}
                  </div>
                  <div class="span-7">
                    {{enumSvc.getFieldCaption("Ablaufplan", "apiKommentar")}}
                  </div>
                </ng-template>
                <ng-template #rowTemplate let-row>
                  <div class="span-3" style="padding-bottom: 8px">
                    <span class="typo-small"
                          [class.app-textdone]="row.apiFreigabe">
                      {{row.apiSequence}}
                    </span>
                    <span flow="right"
                          [tooltip]="enumSvc.getFieldCaption('Ablaufplan', 'apiFreigabe')"
                          style="margin-left: 4px">
                      <i class="search-filter-action disabled fa-clipboard-check"
                         [class.app-fa-duotone-green]="row.apiFreigabe"
                         [class.fa-duotone]="row.apiFreigabe"
                         [class.fa-light]="!row.apiFreigabe">
                      </i>
                    </span>
                    <ng-container *ngIf="excSecurity.isFeatured('SCHEDULEMGMT')">
                      <span flow="left"
                            [tooltip]="getResource('inProof')"
                            style="margin-left: 2px">
                        <i class="search-filter-action disabled fa-magnifying-glass"
                           [class.fa-duotone]="row.apiPruefen"
                           [class.fa-light]="!row.apiPruefen">
                        </i>
                      </span>
                      <span flow="left"
                            [tooltip]="enumSvc.getFieldCaption('Ablaufplan', 'apiMonitoring')"
                            style="margin-left: 2px">
                        <i class="search-filter-action disabled fa-monitor-waveform"
                           [class.fa-duotone]="row.apiMonitoring"
                           [class.fa-light]="!row.apiMonitoring">
                        </i>
                      </span>
                    </ng-container>
                  </div>
                  <div class="span-5 typo-small"
                       [class.app-textdone]="row.apiFreigabe">
                    {{row.apiBezeichnung}}
                  </div>
                  <div class="span-3 typo-small"
                       [class.app-textdone]="row.apiFreigabe">
                    {{row.apiSollDatum |excDate}}
                  </div>
                  <div class="span-3 typo-small"
                       [class.app-textdone]="row.apiFreigabe">
                    {{row.apiPlanDatum |excDate}}
                  </div>
                  <div class="span-3 typo-small"
                       [class.app-textdone]="row.apiFreigabe">
                    {{row.apiIstDatum |excDate}}
                  </div>
                  <div class="span-6 typo-small"
                       [class.app-textdone]="row.apiFreigabe">
                    {{row.apiKommentar}}
                  </div>
                  <div class="typo-center">
                    <i class="search-action fa-duotone fa-pencil" (click)="updateScheduleWithRow(row)"></i>
                  </div>
                </ng-template>
              </exg-data-table>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <!--DRAWER RIGHT-->
    <div class="content drawer-container right app-table-drawer" style="padding-bottom: .5rem;">
      <div [ngClass]="{'visible': rightDrawerVisible }"
           class="drawer-content md3-card-on-surface app-space-right_0 app-space-top">
        <div class="content width-500">
          <div *ngIf="CaseSummary?.caseDetails?.isLoading" class="splash loading">
            <div class="spinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <exg-tab [hidden]="CaseSummary?.caseDetails?.isLoading" #VCrightTabControl [header]="rightTabs">
            <ng-template #pages>
              <div class="content">
                <app-drawer-case-details
                  [data]="CaseSummary?.caseDetails?.data"
                  [oeList]="CaseSummary?.oeList?.data"
                  [Schadenort]="CaseSummary?.Schadenort?.data">
                </app-drawer-case-details>
              </div>
              <div class="content">
                <div class="layout-1-auto">
                  <div class="content">
                    <div *ngIf="config.taskDetails.state === 2" class="splash empty">
                      <p>{{getTranslation('Es wurden keine Daten gefunden!')}}</p>
                    </div>
                    <exg-data-list #VCtaskList
                                   (RowChange)="config.taskDetails.selectionChanged($event)"
                                   [allowSingleSelection]="true"
                                   [displayState]="config.taskDetails.state"
                                   [rowSource]="CaseSummary?.taskList?.data"
                                   [selectKey]="config.taskDetails.selectKey"
                                   class="list"
                                   [selectSource]="config.taskDetails.selectedRow"
                                   (RowDblClick)="config.onDblClickTaskWorkspace($event)">
                      <ng-template #rowTemplate let-task>
                        <div class="list-row  list-row-1-auto app-list">
                          <div class="typo-container-s-s-q typo-small">
                            <span class="">
                              {{enumSvc.getEnumerationText('VorgangStatus', task?.vorg_enmIdent_VorgangStatus)}}
                              - {{enumSvc.getEnumerationText('VorgangTyp', task?.vorg_enmIdent_VorgangTyp)}}
                            </span>
                            <span></span>
                            <q></q>
                            <span class="app-list-row-boldline">
                              {{task.vorgNr ? 'Vorgang - ' + task.vorgNr :
                              getResource('EmptyColumn.vorgNr')}}
                            </span>
                            <span></span>
                            <q></q>
                            <ng-container *ngIf="task.vorgBeschreibung?.toString().length > 0">
                              <span class="list-secondary-text app-list-text">
                                {{task.vorgBeschreibung?.toString().slice(0, 64)}}{{task.vorgBeschreibung?.length >= 64 ?
                                '...' : ''}}
                              </span>
                              <span></span>
                              <q></q>
                            </ng-container>
                          </div>
                          <div class="list-metadata ">
                            <div class="typo-right">{{task.vorgLCD | excDate: 'Globals.DateTimeFormatShort'}}</div>
                            <div class="typo-right">{{task.vorgLCU}}</div>
                            <div class="typo-right">
                              <ng-container *ngIf="config.getOEByID(task.vorg_oid_Bearbeiter) as OE">
                                <span>SV: {{OE.oeEName}} {{OE.oeName}}</span>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </exg-data-list>
                  </div>
                  <div>
                  </div>
                </div>
              </div>
              <div class="content">
                <app-tab-task-attachment
                  *ngIf="!CaseSummary?.caseDetails?.isLoading"
                  [entityID]="CaseSummary?.ID"
                  [entityType]="'case'"
                  [SummaryAttachmentTable]="CaseSummary?.attachmentJagTable"
                  [ConfigAttachmentTable]="config.attachmentJagTable"
                  [Events]="Events">
                </app-tab-task-attachment>
              </div>
	            <!--4 - Belege -->
	            <div class="content">
		            <app-tab-task-receipt *ngIf="!CaseSummary?.caseDetails?.isLoading"
                                      [ConfigReceiptTable]="config.receiptList"
                                      [SummaryReceiptTable]="CaseSummary?.receiptList"
                                      [tableDrawerIsLoading]="CaseSummary?.caseDetails?.isLoading"
                                      [Events]="Events">
		            </app-tab-task-receipt>
	            </div>
              <div class="content">
                <exg-data-list [allowSingleSelection]="false"
                               [displayState]="config.flowTable.state"
                               [rowSource]="CaseSummary?.flowTable.data"
                               selectKey="lnkID">
                  <ng-template #rowTemplate let-row>
                    <div class="list-row list-single-line grid-auto-1">
                      <div class="list-avatar nobackground row-span-2" style="cursor: pointer"
                           (click)="config.openLink(row)"><i
                        class="{{getTranslation('Icons.' + row.lnkTable)}}"></i></div>
                      <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                        <div class="list-metadata" style="margin-left:0">
                          <span style="padding-right: 0.25rem">{{row.Etikett}}</span>
                          <span style="letter-spacing: 0.25rem">
                            <ng-container *ngIf="row.Etikett === 'Nachricht'">
                              <i class="fal fa-inbox-in" *ngIf="row.lnkImageUrl.indexOf('In')>-1"></i>
                              <i class="fal fa-inbox-out" *ngIf="row.lnkImageUrl.indexOf('Out')>-1"></i>
                              <i class="fal fa-paperclip" *ngIf="row.lnkImageUrl.indexOf('Anhang')>-1"></i>
                              <i class="fal fa-check" *ngIf="row.lnkImageUrl.indexOf('Done')>-1"></i>
                              <i class="fal fa-location" *ngIf="row.lnkImageUrl.indexOf('EXAKT')>-1"></i>
                            </ng-container>
                            <ng-container *ngIf="row.Etikett === 'Aufgabe'">
                              <i class="fal fa-check" *ngIf="row.lnkImageUrl.indexOf('Done')>-1"></i>
                            </ng-container>
                          </span>
                        </div>
                        <div class="list-metadata">
                          <div
                            class="typo-right">{{row.lnkCRD | excDate: 'Globals.DateTimeFormatShort'}}</div>
                          <div class="typo-right">{{row.lnkCRU}}</div>
                        </div>
                        <div class="span-2"><strong>{{row.lnkName}}</strong></div>
                        <div class="span-2 list-secondary-text"></div>
                      </div>
                    </div>
                  </ng-template>
                </exg-data-list>
              </div>
              <div class="content">
                <exg-data-list [allowSingleSelection]="false"
                               [rowSource]="CaseSummary?.dialogueQuestions?.data"
                               selectKey="dfID">
                  <ng-template #rowTemplate let-row>
                    <div class="list-row list-single-line-auto-1 typo-small">
                      <div><strong>{{row.dfText}}</strong></div>
                      <div class="list-secondary-text"
                           *ngIf="row.deValue && row.deValue.length > 0">{{row.deValue}}</div>
                      <div class="list-secondary-text" style="font-style: italic"
                           *ngIf="!row.deValue || row.deValue.length === 0">&lt;&lt;Die Frage wurde noch nicht
                        beantwortet&gt;&gt;
                      </div>
                    </div>
                  </ng-template>
                </exg-data-list>
              </div>
            </ng-template>
          </exg-tab>
        </div>
      </div>
    </div>
  </div>
  <!--ICON BAR RIGHT-->
  <div class="app-drawer md3-card-on-surface app-height-auto app-space-top" style="overflow: visible">
    <i (click)="rightDrawerVisible = !rightDrawerVisible" class="search-filter-action fal fa-info"
       [tooltip]="getResource('openDetails')" flow="left"></i>
    <i class="search-filter-seperator"></i>
	  <i (click)="openWorkspaceV2()"
	     class="search-filter-action fal fa-code"
	     [tooltip]="getRessource('tooltip.openWorkspace')" flow="left">
	  </i>
	  <i class="search-filter-seperator"></i>
    <app-exg-dropdown *ngIf="!editMode">
      <ng-template #hostTemplate>
        <i class="search-filter-action fal fa-ellipsis-v"
           [class.disabled]="!isWorkflowActive()"
           [tooltip]="!isWorkflowActive()?'Keine Workfloweinträge verfügbar':'Workflowmenü'" flow="left">
        </i>
      </ng-template>
      <ng-template #contentTemplate let-popup>
        <div *ngFor="let row of workFlowMenu">
          <div class="list-row list-single-line  typo-small" style="cursor:pointer" (click)="row.click(); popup.close()"
               *ngIf="row.visible">{{row.caption}}</div>
        </div>
      </ng-template>
    </app-exg-dropdown><!--[disabled]="CaseSummary?.isLoading"-->
    <i (click)="config.openEditMode()" class="search-filter-action fal fa-pencil"
       *ngIf="!editMode"
       [class.disabled]="CaseSummary?.isLoading || !excSecurity.isFeatured('CASEEDIT')"
       [tooltip]="getResource('EditMode')" flow="left"></i>
    <i (click)="config.saveEditMode()" class="search-filter-action fal fa-floppy-disk"
       *ngIf="editMode"
       [class.disabled]="CaseSummary?.isLoading  || !excSecurity.isFeatured('CASEEDIT')"
       [tooltip]="getResource('SaveEditMode')" flow="left"></i>
    <i (click)="config.cancelEditMode()" class="search-filter-action fal fa-xmark"
       *ngIf="editMode"
       [class.disabled]="CaseSummary?.isLoading"
       [tooltip]="getResource('CancelEditMode')" flow="left"></i>
    <i class="search-filter-seperator"></i>
    <app-exg-dropdown *ngIf="!editMode" position="underleft">
      <ng-template #hostTemplate>
        <i class="search-filter-action fal fa-plus"
           [tooltip]="'Hinzufügen'" flow="left"
           [class.disabled]=""></i>
      </ng-template>
      <ng-template #contentTemplate let-popup>
        <div class="content" style="max-height: 500px">
          <div (click)="config.newReport(); popup.close();" class="md-menu-item">Bericht</div>
          <div *ngIf="!(CaseSummary?.defaultMessages?.data.length > 0)"
               (click)="config.newMessage(); popup.close();"
               class="md-menu-item">Nachricht
          </div>
          <app-exg-dropdown *ngIf="CaseSummary?.defaultMessages?.data.length > 0" [adaptiveHeightActive]="true">
            <ng-template #hostTemplate>
              <div class="md-menu-item">Nachricht...</div>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <div (click)="config.newMessage();popup.close();" class="md-menu-item typo-left">Leere Nachricht</div>
              <ng-container *ngFor="let row of CaseSummary?.defaultMessages?.data">
                <div (click)="config.newDefaultMessage(row.dmsgID);popup.close();"
                     class="md-menu-item typo-left">{{row.dmsgBezeichnung}}</div>
              </ng-container>
            </ng-template>
          </app-exg-dropdown>
          <div *ngIf="excSecurity.isFeatured('NTZEDIT')"
               (click)="config.newNote();popup.close();" class="md-menu-item">
            Notiz
          </div>
          <div (click)="config.showAttachmentUploadModal(); popup.close();" class="md-menu-item">Anlage</div>
          <div *ngIf="excSecurity.isFeatured('TASKCREATE')" (click)="createNewTask(); popup.close();"
               class="md-menu-item">Vorgang
          </div>
        </div>
      </ng-template>
    </app-exg-dropdown>
    <i class="search-filter-action fal fa-image" (click)="config.showAttachmentPreview()"
       [class.disabled]="CaseSummary?.isLoading"
       [tooltip]="'Anlagen ansehen'"
       flow="left"></i>
    <i (click)="config.showHistory()" class="search-filter-action {{getResource('Tabs.History.Icon')}}"
       [class.disabled]="CaseSummary?.isLoading"
       [tooltip]="'Historie'" flow="left"></i>
    <i class="search-filter-seperator"></i>
    <i class="search-filter-action fa-light fa-folders"
       *ngIf="excSecurity.isFeatured('DOCUMENTMGMT')"
       (click)="openFileOverview()"
       [tooltip]="'Dokumenten Manager'"
       flow="left"></i>
    <i class="search-filter-action fa-light fa-screwdriver-wrench"
       *ngIf="excSecurity.isFeatured('DEVELOPMENT')"
       (click)="openReportBuilder()"
       [tooltip]="'Neuen Report erstellen'"
       flow="left"></i>
  </div>
</div>
<ng-container *ngIf="CaseSummary?.caseDetails?.isLoading">
  <div class="splash loading">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</ng-container>
